import React, { useEffect, useState } from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import axios from 'axios';

ChartJS.register(ArcElement, Tooltip, Legend);

const JobSeekerStatistics = () => {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}jobseeker/jobseeker-stats`);
        setStats(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching stats:', error);
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  const generateChartData = (data, label, labels, colors) => ({
    labels,
    datasets: [
      {
        label,
        data: labels.map((l) => data[l] || 0),
        backgroundColor: colors,
        borderColor: colors.map((color) => color.replace('0.6', '1')),
        borderWidth: 1,
      },
    ],
  });

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { position: 'top' },
      tooltip: { enabled: true },
    },
  };

  const maritalStatusLabels = ['single', 'married', 'divorced', 'widower', 'separated', 'widow'];
  const educationLevelLabels = ['masters', 'PHD', 'graduate', 'undergraduate', 'SSCE', 'none', 'others'];
  const genderLabels = ['male', 'female'];
  const ageBracketLabels = ['16-25', '26-35', '36-45', '46-55'];

  const colors = [
    'rgba(255, 99, 132, 0.6)',
    'rgba(54, 162, 235, 0.6)',
    'rgba(255, 206, 86, 0.6)',
    'rgba(75, 192, 192, 0.6)',
    'rgba(153, 102, 255, 0.6)',
    'rgba(255, 159, 64, 0.6)',
    'rgba(199, 199, 199, 0.6)',
  ];

  if (loading) return <div>Loading...</div>;

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Job Seeker Statistics by State</h1>
      {stats.map((stateData) => (
        <div key={stateData.state} className="mb-8">
          <h2 className="text-xl font-semibold">{stateData.state || 'Unknown State'}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <div>
              <h3 className="text-lg font-medium">Marital Status</h3>
              <Pie
                data={generateChartData(
                  stateData.maritalStatusCounts,
                  'Marital Status',
                  maritalStatusLabels,
                  colors
                )}
                options={chartOptions}
              />
              <ul className="mt-2">
                {maritalStatusLabels.map((label) => (
                  <li key={label}>
                    {label}: {stateData.maritalStatusCounts[label] || 0}
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-medium">Education Level</h3>
              <Pie
                data={generateChartData(
                  stateData.educationLevelCounts,
                  'Education Level',
                  educationLevelLabels,
                  colors
                )}
                options={chartOptions}
              />
              <ul className="mt-2">
                {educationLevelLabels.map((label) => (
                  <li key={label}>
                    {label}: {stateData.educationLevelCounts[label] || 0}
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-medium">Gender</h3>
              <Pie
                data={generateChartData(
                  stateData.genderCounts,
                  'Gender',
                  genderLabels,
                  colors
                )}
                options={chartOptions}
              />
              <ul className="mt-2">
                {genderLabels.map((label) => (
                  <li key={label}>
                    {label}: {stateData.genderCounts[label] || 0}
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-medium">Age Brackets</h3>
              <Pie
                data={generateChartData(
                  stateData.ageBracketCounts,
                  'Age Brackets',
                  ageBracketLabels,
                  colors
                )}
                options={chartOptions}
              />
              <ul className="mt-2">
                {ageBracketLabels.map((label) => (
                  <li key={label}>
                    {label}: {stateData.ageBracketCounts[label] || 0}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default JobSeekerStatistics;